import React from "react";
import { withRouter } from "react-router-dom";

import GatewaysService from "../../../services/gateways/GatewaysService";

import Gateway from "@cdkglobal/epay-admin-component/cjs/components/_onePay/middle/gateway/Gateway";
import AdminPage from "./../common/AdminPage";

const GatewayPage = ({ history }) => {
  return (
    <AdminPage showGoBackLink={true} history={history}>
      <Gateway
        loadGateways={GatewaysService.getGateways}
        loadGatewayDetail={GatewaysService.getGateway}
        onSave={GatewaysService.updateGateway}
      />
    </AdminPage>
  );
};

export default withRouter(GatewayPage);
